<div class="inputTitle" *ngIf="label">
    <span>{{ label }}
        <i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay" id="i1"
            class="flaticon-message" *ngIf="tooltipIcon"></i>
    </span>
</div>

<div [class.has-errors]="errors?.length" class="moneyForm" [hidden]="!isEditable">
    <div fxLayout="row" class="webMoney">
        <mat-form-field appearance="outline">
            <input matInput type="number" [name]="formFieldName" [ngModel]="days" (ngModelChange)="setDays($event)"
                [disabled]="disabled" [min]="minValue" [max]="maxValue" [maxlength]="maxlength" [minlength]="minlength"
                oninput="if (value.length > maxLength) value = value.slice(0, maxLength);" (keypress)="default($event)">
        </mat-form-field>
        <div class="select" fxFlex="49px">
            <span class="duration">{{_duration.duration}}</span>
            <!-- <app-select-field [isEditable]="false" [(ngModel)]="_duration" [name]="'duration'"
                [displayField]="'duration'" [options]="durationList" fxLayout="column">
            </app-select-field> -->
        </div>
    </div>
</div>

<div class="viewLable" [hidden]="isEditable">
    <span>
        {{ getDisplay() }}
    </span>
</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{ item }}</li>
</ul>